import { default as Divider, DividerProps as Props } from "antd/lib/divider";
import React from "react";

export const Component: Component<{
  readonly titleOrientation: Props["orientation"];
  readonly children?: Props["children"];
  readonly type?: Props["type"];
}> = ({ children, titleOrientation, type }) => (
  <Divider orientation={titleOrientation} type={!type ? type : "horizontal"}>
    {children}
  </Divider>
);
